const webpackLoadersByModuleId = {
  'login/app': () => import(/* webpackChunkName: "login/app" */ './login/app'),
  'launcher/app': () => import(/* webpackChunkName: "launcher/app" */ './launcher/app'),
  'site-select/app': () => import(/* webpackChunkName: "site-select/app" */ './site-select/app'),
  'services/services': () => import(/* webpackChunkName: "services/services" */ './services/services'),
  '156085c5-0017-4150-b225-a731ad248f38/service': () => import(/* webpackChunkName: "156085c5-0017-4150-b225-a731ad248f38/service" */ './156085c5-0017-4150-b225-a731ad248f38/service'),
  'services/index': () => import(/* webpackChunkName: "services/index" */ './services/index'),
};

module.exports = {
  require: (moduleIds, cb) => Promise.all(moduleIds.map((moduleId) => {
    if (moduleId in webpackLoadersByModuleId) {
      return webpackLoadersByModuleId[moduleId]();
    }

    console.warn('unknown module', moduleId);

    return Promise.resolve(undefined);
  })).then((modules) => cb.apply(
    this,
    modules.map(module => module?.default || module),
  )),
};
